import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  ContainerButtons,
  Column,
  NonContacts,
  Field,
  FieldInfo,
  Button,
  ButtonDelete,
  DeleteSx,
} from "./style";
import {
  Person,
  Mail,
  Delete,
  Check,
  Block,
  Pending,
} from "@mui/icons-material";
import FormDialog from "./password";
import { ContactContext } from "../../../../../context/contact/ContactContext";
import Wait from "../../../../Wait";
import UpdateDialog from "./updateDialog";
import DeleteDialog from "./delete";
import { useTranslation } from "react-i18next";
import { LinearProgress } from "@mui/material";
import { Tittle } from "../style";

const SecondAccount = () => {
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [dialogUpdate, setShowDialogUpdate] = useState(false);
  const [success, setSuccess] = useState(false);
  const [updateWindow, setUpdateWindow] = useState(false);
  const [contactUpdate, setContactUpdate] = useState({});
  const {
    getAllSecondaryContact,
    currentContact,
    secondaryContact,
    setApproval,
  } = useContext(ContactContext);

  const handleOpenDialog = (infoContact) => {
    setContactUpdate(infoContact);
    setShowDialog(true);
  };
  const handleOpenDeleteDialog = (infoContact) => {
    setContactUpdate(infoContact);
    setShowDeleteDialog(true);
  };
  const sendApproval = async (infoContact) => {
    setShowDialogUpdate(true);
    const data = {
      guid: infoContact.id,
      firstName: infoContact.givenName,
      lastName: infoContact.surname,
      email: infoContact.mail,
    };
    await setApproval(infoContact);
    setSuccess(true);
    setUpdateWindow(true);
    setTimeout(() => {
      setShowDialogUpdate(false);
    }, 1500);
  };
  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getAllSecondaryContact(currentContact.guid)]);
      setLoading(false);
    };
    fetchData2();
  }, [updateWindow]);

  // if (isLoading) {
  //   return <Wait />;
  // }
  if (secondaryContact.length > 0) {
    let data = secondaryContact;
    data.map((contact) => {
      let tempContact = contact;
      tempContact["isPendingApproval"] =
        !tempContact.mongoObj.useR_SIGNUP[0].activE_STATE &&
        !tempContact.mongoObj.useR_SIGNUP[0].approvaL_STATE &&
        tempContact.mongoObj.useR_SIGNUP[0].pendinG_APPROVAL;
      tempContact["isDeleted"] =
        !tempContact.mongoObj.useR_SIGNUP[0].activE_STATE &&
        !tempContact.mongoObj.useR_SIGNUP[0].approvaL_STATE &&
        !tempContact.mongoObj.useR_SIGNUP[0].pendinG_APPROVAL;
      tempContact["isActive"] =
        tempContact.mongoObj.useR_SIGNUP[0].activE_STATE &&
        tempContact.mongoObj.useR_SIGNUP[0].approvaL_STATE &&
        !tempContact.mongoObj.useR_SIGNUP[0].pendinG_APPROVAL;
    });
  }
  return (
    <>
      {isLoading && <LinearProgress color="error" />}
      <Tittle>{t("usersManagement")}</Tittle>
      <br />
      {dialogUpdate && (
        <UpdateDialog
          success={success}
          showDialogUpdate={dialogUpdate}
          setShowDialogUpdate={setShowDialogUpdate}
        />
      )}
      {showDialog && (
        <FormDialog
          contactUpdate={contactUpdate}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />
      )}
      {showDeleteDialog && (
        <DeleteDialog
          contactUpdate={contactUpdate}
          showDialog={showDeleteDialog}
          setShowDialog={setShowDeleteDialog}
          setUpdateWindow={setUpdateWindow}
        />
      )}
      <Container>
        {secondaryContact.length > 0 ? (
          secondaryContact.map((contact) => (
            <Column key={contact.id}>
              <Field>
                <Person />
                &nbsp; {t("name")}
              </Field>
              <FieldInfo>{contact.givenName + " " + contact.surname}</FieldInfo>
              <Field>
                <Mail />
                &nbsp; {t("email")}
              </Field>
              <FieldInfo>{contact.mail}</FieldInfo>
              {contact.isPendingApproval ? (
                <>
                  <Field>
                    <Pending />
                    &nbsp; {t("state")}
                  </Field>
                  <FieldInfo>{t("pendingApproval")}</FieldInfo>
                </>
              ) : contact.isActive ? (
                <>
                  <Field>
                    <Check />
                    &nbsp; {t("state")}
                  </Field>
                  <FieldInfo>{t("active")}</FieldInfo>
                </>
              ) : (
                contact.isDeleted && (
                  <>
                    <Field>
                      <Block />
                      &nbsp; {t("state")}
                    </Field>
                    <FieldInfo>{t("inactive")}</FieldInfo>
                  </>
                )
              )}
              <ContainerButtons deleted={contact.isDeleted.toString()}>
                {contact.isPendingApproval && (
                  <>
                    <br />
                    <Button
                      deleted={contact.isDeleted.toString()}
                      onClick={() => sendApproval(contact)}
                    >
                      {t("approve")}
                    </Button>
                  </>
                )}
                <br />
                <br />
                <Button
                  deleted={contact.isDeleted.toString()}
                  onClick={() => handleOpenDialog(contact)}
                >
                  {t("changePassword")}
                </Button>
              </ContainerButtons>
              <ButtonDelete deleted={contact.isDeleted.toString()}>
                <Delete
                  onClick={() => handleOpenDeleteDialog(contact)}
                  sx={DeleteSx}
                />
              </ButtonDelete>
            </Column>
          ))
        ) : (
          <NonContacts>
            <h2>{t("noAssignedContacts")}</h2>
          </NonContacts>
        )}
        <br />
      </Container>
    </>
  );
};

export default SecondAccount;
